import React from 'react';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import { humanizeNumber, sentenceCase } from '../../helpers/formatters';
import { entityLabelMatcher } from '../../helpers/label-mapper';

const MapBanner = ({ council, comparing, onCloseClicked }) => {
  return (
    <div
      className={`${styles.banner} ${styles.mapBanner}`}
      data-comparing={comparing}
    >
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" style={{ height: 10, width: 10 }} />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.lgaName}</h2>
      <div className={styles.mapBannerWrapper}>
        <div className={styles.mapBannerDataRow}>
          <div
            className={styles.mapBannerDataBlockWrapper}
            style={{ marginRight: 40 }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/img/people-icon.svg`}
              alt="house icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.population, 'number')}
              </div>
              <span>people</span>
            </div>
          </div>

          <div
            className={styles.mapBannerDataBlockWrapper}
            style={{ marginRight: 40 }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/img/income-icon.svg`}
              alt="people icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.medianIncome, 'currency')}
              </div>
              <span>median income</span>
            </div>
          </div>

          <div className={styles.mapBannerDataBlockWrapper}>
            <img
              src={`${process.env.PUBLIC_URL}/img/age-icon.svg`}
              alt="area icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.medianAge, 'number')}
              </div>
              <span>median age</span>
            </div>
          </div>
          <div className={styles.mapBannerLegend}>
            <span> This demographic data was sourced from</span>
            <a
              className={styles.externalLink}
              href="https://dbr.abs.gov.au/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Australian Bureau of Statistics, data by region{' '}
            </a>
            and represents the average of median statistics for the local
            government areas that make up this region.
          </div>
        </div>
        <div className={styles.mapBannerInfoContainer}>
          <p className={styles.mapBannerInfo}>
            <span className={styles.mapBannerInfoKey}>Region: </span>
            <span className={styles.mapBannerInfoValue}>
              {entityLabelMatcher(
                council.highLevelClassification,
                'map-banner'
              )}
            </span>
          </p>
          <p className={styles.mapBannerInfo}>
            <span className={styles.mapBannerInfoKey}>Drought status: </span>
            <span className={styles.mapBannerInfoValue}>
              {council.droughtStatus}
            </span>
          </p>
          <p className={styles.mapBannerInfo}>
            <span className={styles.mapBannerInfoKey}>
              Primary industries:{' '}
            </span>
            <span className={styles.mapBannerInfoValue}>
              {sentenceCase(council.rtpPrimaryIndustrySector)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/region-map-container/map-banner.js